export default "<narwhalia-crispr-sidebar class=\"sidebar\"></narwhalia-crispr-sidebar>\r\n<narwhalia-crispr-list></narwhalia-crispr-list>\r\n";